import { render, staticRenderFns } from "./DownloadSC.vue?vue&type=template&id=55bdc884"
import script from "./DownloadSC.vue?vue&type=script&lang=js"
export * from "./DownloadSC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports